import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router";
import { useWorkspaceContext } from "@core/context";
import { getApprovalInfo } from "@modules/docs/annotations/services";
import type { TApprovalItem } from "@modules/docs/approvals/types/TApproval";

export function useGetApprovalInfo() {
  const { workspaceId } = useWorkspaceContext();
  const { projectId } = useParams<{ projectId: string }>();
  const [searchParams] = useSearchParams();
  const approvalId = searchParams.get("approval_id") ?? "";

  return useQuery<TApprovalItem>({
    queryKey: ["approval-info", workspaceId, projectId, approvalId],
    queryFn: () => getApprovalInfo(workspaceId, projectId!, approvalId),
    enabled: !!workspaceId && !!projectId && !!approvalId,
  });
}
